<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="模板名称" prop="templateName">
        <el-input
          v-model="queryParams.templateName"
          class="!w-240px"
          clearable
          placeholder="请输入模板名称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="queryParams.status"
          class="!w-240px"
          clearable
          placeholder="请选择状态"
        >
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:hourly-template:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="模板编码" prop="templateCode" min-width="120" />
      <el-table-column align="center" label="模板名称" prop="templateName" min-width="150" />
      <el-table-column align="center" label="开始时段" prop="timeSlotStart" min-width="100" />
      <el-table-column align="center" label="结束时段" prop="timeSlotEnd" min-width="100" />
      <el-table-column align="center" label="基础时长" prop="baseHours" min-width="100">
        <template #default="scope">
          {{ scope.row.baseHours }} 小时
        </template>
      </el-table-column>
      <el-table-column align="center" label="基础价格" prop="basePrice" min-width="100">
        <template #default="scope">
          {{ scope.row.basePrice != null ? '￥' + scope.row.basePrice : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="加时单价" prop="overtimeRate" min-width="100">
        <template #default="scope">
          {{ scope.row.overtimeRate != null ? '￥' + scope.row.overtimeRate : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="适用房型" prop="applicableRoomTypes" min-width="150" show-overflow-tooltip />
      <el-table-column align="center" label="状态" prop="status" min-width="80">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.COMMON_STATUS" :value="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:hourly-template:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:hourly-template:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="SPU ID" prop="spuId">
        <el-input v-model="formData.spuId" placeholder="请输入SPU ID" />
      </el-form-item>
      <el-form-item label="模板编码" prop="templateCode">
        <el-input v-model="formData.templateCode" placeholder="请输入模板编码" />
      </el-form-item>
      <el-form-item label="模板名称" prop="templateName">
        <el-input v-model="formData.templateName" placeholder="请输入模板名称" />
      </el-form-item>
      <el-form-item label="开始时段" prop="timeSlotStart">
        <el-time-select
          v-model="formData.timeSlotStart"
          :max-time="formData.timeSlotEnd"
          placeholder="请选择开始时段"
          start="00:00"
          step="00:30"
          end="23:30"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="结束时段" prop="timeSlotEnd">
        <el-time-select
          v-model="formData.timeSlotEnd"
          :min-time="formData.timeSlotStart"
          placeholder="请选择结束时段"
          start="00:00"
          step="00:30"
          end="23:30"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="基础时长" prop="baseHours">
        <el-input-number
          v-model="formData.baseHours"
          :min="1"
          :max="24"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="基础价格" prop="basePrice">
        <el-input-number
          v-model="formData.basePrice"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="加时单价" prop="overtimeRate">
        <el-input-number
          v-model="formData.overtimeRate"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="适用房型" prop="applicableRoomTypes">
        <el-input
          v-model="formData.applicableRoomTypes"
          placeholder="请输入适用房型（多个用逗号分隔）"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :value="dict.value"
          >
            {{ dict.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import * as HourlyTemplateApi from '@/api/hotel/hourlyTemplate'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import { CommonStatusEnum } from '@/utils/constants'

defineOptions({ name: 'HotelHourlyTemplate' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  templateName: undefined,
  status: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await HourlyTemplateApi.getHourlyTemplatePage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<HourlyTemplateApi.HourlyTemplateVO>({
  id: undefined,
  shopId: undefined,
  spuId: undefined,
  templateCode: '',
  templateName: '',
  timeSlotStart: '',
  timeSlotEnd: '',
  baseHours: 1,
  basePrice: 0,
  overtimeRate: 0,
  applicableRoomTypes: '',
  status: CommonStatusEnum.ENABLE,
  createTime: undefined as any
})
const formRules = reactive({
  templateCode: [{ required: true, message: '模板编码不能为空', trigger: 'blur' }],
  templateName: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
  timeSlotStart: [{ required: true, message: '开始时段不能为空', trigger: 'change' }],
  timeSlotEnd: [{ required: true, message: '结束时段不能为空', trigger: 'change' }],
  baseHours: [{ required: true, message: '基础时长不能为空', trigger: 'blur' }],
  basePrice: [{ required: true, message: '基础价格不能为空', trigger: 'blur' }],
  overtimeRate: [{ required: true, message: '加时单价不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '状态不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await HourlyTemplateApi.getHourlyTemplate(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await HourlyTemplateApi.createHourlyTemplate(data)
      message.success(t('common.createSuccess'))
    } else {
      await HourlyTemplateApi.updateHourlyTemplate(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    shopId: undefined,
    spuId: undefined,
    templateCode: '',
    templateName: '',
    timeSlotStart: '',
    timeSlotEnd: '',
    baseHours: 1,
    basePrice: 0,
    overtimeRate: 0,
    applicableRoomTypes: '',
    status: CommonStatusEnum.ENABLE,
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await HourlyTemplateApi.deleteHourlyTemplate(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getShopList()
})
</script>
